(function () {
  'use strict';

  // Simple promise-cache so the same product isn't fetched twice in a session
  var _cache = new Map();
  function cachedGet(url) {
    if (!_cache.has(url)) {
      _cache.set(url, fetch(url).then(function (r) {
        if (!r.ok) throw new Error('fetch error ' + r.status);
        return r.text();
      }).catch(function (err) {
        _cache.delete(url);
        throw err;
      }));
    }
    return _cache.get(url);
  }

  function el(tag, cls) {
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    return d;
  }

  function buildSkeleton() {
    var wrap = el('div', 'jn-qb-skel');

    // Gallery column
    var gallery = el('div', 'jn-qb-skel__gallery');
    gallery.appendChild(el('div', 'jn-qb-skel__shim jn-qb-skel__img'));
    wrap.appendChild(gallery);

    // Info column
    var info = el('div', 'jn-qb-skel__info');

    function row(cls) { info.appendChild(el('div', 'jn-qb-skel__shim ' + cls)); }

    row('jn-qb-skel__vendor');
    row('jn-qb-skel__title');
    row('jn-qb-skel__price');
    row('jn-qb-skel__label');

    var swatches = el('div', 'jn-qb-skel__row');
    for (var i = 0; i < 3; i++) swatches.appendChild(el('div', 'jn-qb-skel__shim jn-qb-skel__swatch'));
    info.appendChild(swatches);

    row('jn-qb-skel__label');

    var sizes = el('div', 'jn-qb-skel__row');
    for (var j = 0; j < 5; j++) sizes.appendChild(el('div', 'jn-qb-skel__shim jn-qb-skel__size'));
    info.appendChild(sizes);

    row('jn-qb-skel__atc');

    wrap.appendChild(info);
    return wrap;
  }

  function patch() {
    var Cls = customElements.get('quick-buy-modal');
    if (!Cls) return;

    // Grab Modal.prototype.show (the grandparent show that opens the dialog)
    var modalShow = Object.getPrototypeOf(Cls.prototype).show;

    Cls.prototype.show = async function () {
      // Open the modal immediately with a skeleton so UX feels instant
      this.replaceChildren(buildSkeleton());
      modalShow.call(this);

      var url = window.Shopify.routes.root + 'products/' + this.getAttribute('handle');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var html;
      try {
        html = await cachedGet(url);
      } catch (_) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.hide();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      var tempDoc = new DOMParser().parseFromString(html, 'text/html');
      var content = tempDoc.getElementById('quick-buy-content') && tempDoc.getElementById('quick-buy-content').content;
      if (!content) { this.hide(); return; }
      content.querySelectorAll('noscript').forEach(function (n) { n.remove(); });
      this.replaceChildren(content);
      window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
    };
  }

  patch();
})();
